import { render } from "./AccountPaymentMethod.vue?vue&type=template&id=f25f1754&scoped=true"
import script from "./AccountPaymentMethod.vue?vue&type=script&lang=js"
export * from "./AccountPaymentMethod.vue?vue&type=script&lang=js"

import "./AccountPaymentMethod.vue?vue&type=style&index=0&id=f25f1754&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25f1754"]])

export default __exports__